export default "__VITE_ASSET__BcrO$Y8w__"